export default function authHeader() {
  return { 'lang-code': localStorage.getItem('lang') };
}